export default __webpack_public_path__ + "static/tb_helles_02_EN-c4d73a0ec6526d9059c0327812ebd576.svg";